import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon ShareIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const ShareIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <g>
        <g id="shareIcon">
          <g>
            <path d="M5.6,24c-2.06-0.13-3.57-1.83-3.47-3.81v-9.53c0-0.74,0.6-1.33,1.33-1.33s1.33,0.6,1.33,1.33v9.6 c-0.03,0.59,0.37,1.04,0.88,1.07h12.72c0.43-0.03,0.83-0.48,0.8-0.99v-9.68c0-0.74,0.6-1.33,1.33-1.33s1.33,0.6,1.33,1.33v9.6 c0.11,1.9-1.41,3.61-3.38,3.73L5.6,24z M12,18.28c-0.74,0-1.33-0.6-1.33-1.33V4.55L8.14,7.08c-0.52,0.52-1.36,0.52-1.89,0 s-0.52-1.36,0-1.89l4.8-4.8C11.31,0.13,11.65,0,12,0l0,0c0.44-0.03,0.75,0.17,0.99,0.44l4.75,4.75c0.52,0.52,0.52,1.36,0,1.89 c-0.52,0.52-1.36,0.52-1.89,0l-2.52-2.52v12.39C13.33,17.68,12.73,18.28,12,18.28z" />
          </g>
        </g>
      </g>
    </Icon>
  )
}
export default ShareIcon
